/* global axios */
import ApiClient from './ApiClient';

class CSATReportsAPI extends ApiClient {
  constructor() {
    super('csat_survey_responses', { accountScoped: true });
  }

  get({ page, from, to, user_ids, inbox_id, team_id, rating, label_id } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        since: from,
        until: to,
        sort: '-created_at',
        user_ids,
        inbox_id,
        team_id,
        rating,
        label_id,
      },
    });
  }

  download({ from, to, user_ids, inbox_id, team_id, rating, label_id, exportFormat, include_contact_custom_attributes } = {}) {
    const isExcel = exportFormat === 'xlsx' || exportFormat === 'excel';
    const path = isExcel ? `${this.url}/download.xlsx` : `${this.url}/download`;
    return axios.get(path, {
      params: {
        since: from,
        until: to,
        sort: '-created_at',
        user_ids,
        inbox_id,
        team_id,
        rating,
        label_id,
        include_contact_custom_attributes,
      },
      responseType: isExcel ? 'arraybuffer' : undefined,
    });
  }

  getMetrics({ from, to, user_ids, inbox_id, team_id, rating, label_id } = {}) {
    // no ratings for metrics
    return axios.get(`${this.url}/metrics`, {
      params: { since: from, until: to, user_ids, inbox_id, team_id, rating, label_id },
    });
  }
}

export default new CSATReportsAPI();
